<template>
  <div class="table-wrapper">
    <div class="table-header">
      <div class="table-header__title">
        <p class="text">
          Apply tags to your distributions to help organize and identify them.
        </p>
      </div>
      <b-button
        v-if="$can('create', 'tags', 'cdn')"
        variant="bg-white"
        :disabled="loading"
        @click="openForm()"
      >
        <GjIcon
          class="icon-left"
          name="Edit"
        />
        Add or Edit Tags
      </b-button>
    </div>
    <!-- DESKTOP -->
    <div class="default-table position-relative d-none d-lg-block">
      <b-table
        :items="tags"
        :fields="fields"
        :class="{'loaded': !loading}"
        select-mode="single"
        show-empty
        responsive
        @row-selected="onRowSelected"
      >
        <template #cell(selected)="{ rowSelected }">
          <select-button :selected="rowSelected" />
        </template>

        <template #empty>
          <div
            v-if="loading"
            class="loading-table text-center py-3"
          >
            <b-spinner variant="primary" />
          </div>
          <template v-else>
            <no-data
              no-data-text="No tags have been added yet..."
              create-text="+ Create Tags"
              access-page="Tags"
              :has-permissions="hasPermissions"
              @action="openForm()"
            />
          </template>
        </template>
      </b-table>
    </div>
    <!-- MOBILE -->
    <div class="position-relative d-lg-none mt-2">
      <div :class="{'opacity-7': loading }">
        <template v-for="tag in tags">
          <card
            :key="tag.id"
            :fields="fields"
            :item="tag"
            class="top-fade-in"
          />
        </template>
      </div>
      <div
        v-if="loading"
        class="mobile-loading"
      >
        <table-busy />
      </div>
      <template v-if="!loading && tags.length < 1">
        <paper-simple class="top-fade-in">
          <no-data
            class="text-center"
            no-data-text="No tags have been added yet..."
            create-text="+ Create Tags"
            access-page="Tags"
            :has-permissions="hasPermissions"
            @action="openForm()"
          />
        </paper-simple>
      </template>
    </div>
  </div>
</template>
<script>
import Card from '@/components/card/Card.vue'

export default {
  name: 'Tags',
  components: {
    Card,
  },
  data() {
    return {
      selected: {},
      fields: [
        { key: 'distributionId', isPrimary: true },
        { key: 'key', isPrimary: true },
        'value',
      ],
      hasPermissions: true,
    }
  },
  computed: {
    tags() {
      return this.$store.state.cdn.tags
    },
    loading() {
      return this.$store.state.cdn.fetchingTags
    },
    tag() {
      return this.selected[0] ? this.selected[0] : {}
    },
  },
  created() {
    this.id = this.$route.params.id
    this.$store.dispatch('cdn/fetchTags', this.id).catch(error => {
      if (error.response?.status === 403) {
        this.hasPermissions = false
        return
      }
      this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while fetching tags.')
    })
  },
  methods: {
    onRowSelected(item) {
      this.selected = item
    },
    openForm() {
      this.$router.push({ name: 'distribution-tags-edit', params: { id: this.id } })
    },
  },
}
</script>
